<template>
  <the-content v-model="showFilters">
    <template v-slot:content>
      <content-spinner v-if="loading" class="ma3"/>
      <div v-else-if="logs.length > 0">
        <div class="list-grid mh2-l mv2">
          <journal-item v-for="(item, index) in logs" :key="index" :itemContext="itemContext(item)" class="list-item" />
        </div>
        <div class="pv3 flex justify-center" v-if="totalCount">
          <paginator :page="validParams.page" routing="false" :total="totalCount" @goto="paginatorRoute"/>
        </div>
      </div>
      <div v-else class="pa2 f6 ttl silver">
        по вашему запросу ничего не найдено
      </div>
    </template>

    <template v-slot:sidebar>
      <filters
        :checked="validParams.statuses"
        :sort="validParams.sort"
        :direction="validParams.direction"
        :contract="{ id: validParams.contract }"
        :stats="stats"
        :placeholders="placeholders"
        @updated="filterRoute"
      />
    </template>

    <template v-slot:mobile-sidebar>
      <filters
        :checked="validParams.statuses"
        :sort="validParams.sort"
        :direction="validParams.direction"
        :contract="{ id: validParams.contract }"
        :stats="stats"
        :placeholders="placeholders"
        @updated="filterRoute"
      />
    </template>

  </the-content>
</template>

<script>
import TheContent from '@/components/Content.vue'
import ContentSpinner from '@/components/common/ContentSpinner.vue'
import JournalItem from '@/components/common/JournalItem.vue'
import Paginator from '@/components/Paginator.vue'
import Filters from '@/components/contracts/Filters.vue'
import { DataService } from '@/services/DataService.js'
import { mapGetters } from 'vuex'

export default {
  components: {
    TheContent,
    ContentSpinner,
    JournalItem,
    Paginator,
    Filters
  },
  props: {
    params: { type: Object }
  },
  watch: {
    validParams: {
      immediate: true,
      handler: function (validParams) {
        const direction = validParams.direction === 'all' ? null : validParams.direction
        const apiParams = {
          filter: {
            ...direction && { direction: direction.toUpperCase() },
            ...validParams.statuses.length > 0 && { status_code: validParams.statuses },
            ...validParams.contract && { contract_id: parseInt(validParams.contract) }
          },
          sort: validParams.sort.toUpperCase(),
          offset: (validParams.page - 1) * this.limit,
          limit: this.limit
        }
        this.loading = true
        this.loadContractsLogs(apiParams).finally(() => { this.loading = false })
        this.getContractLogsStats(apiParams)
      }
    }
  },
  computed: {
    ...mapGetters('contract', ['status_by_code']),
    validParams () {
      const statuses = Array.isArray(this.params.statuses)
        ? this.params.statuses
        : this.params.statuses ? [this.params.statuses] : []
      return {
        direction: this.params.direction || 'all',
        page: this.params.page || 1,
        sort: this.params.sort || 'desc',
        statuses,
        contract: this.params.contract
      }
    },
    totalCount () {
      return this.totalItems % this.limit
        ? Math.floor(this.totalItems / this.limit) + 1
        : this.totalItems / this.limit
    }
  },
  data () {
    return {
      placeholders: {
        company: 'Контрагент'
      },
      showFilters: false,
      stats: {},
      logs: [],
      totalItems: 0,
      limit: 20,
      loading: false
    }
  },
  methods: {
    paginatorRoute (where) {
      this.$router.push({ name: this.$router.name, query: { ...this.validParams, page: where.query.page } })
    },
    filterRoute (update) {
      this.$router.push({ name: this.$router.name, query: { ...this.validParams, ...update, page: 1 } })
    },
    async loadContractsLogs (params) {
      return DataService.getContractLogs(params)
        .then(({ data: { contract_logs: { items, total_count: totalCount } } }) => {
          this.logs = items
          this.totalItems = totalCount
        })
    },
    async getContractLogsStats (params) {
      return DataService.getContractLogsStats(params)
        .then(({ data: { contract_logs_stats: logStats } }) => {
          this.stats = logStats.reduce(function (map, obj) {
            map[obj.group] = obj.count || 0
            return map
          }, {})
        })
    },
    itemContext (item) {
      return {
        item: item,
        statusByCode: (code) => this.status_by_code(code),
        cardLink: 'contract_card',
        parentId: item.contractId,
        parentTitle: item.contractTitle || 'Договор ' + item.contractId,
        showTitle: true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
